// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Specifies a Microsoft Entra region.
 * @export
 * @enum {string}
 */
export enum AzureStorageEndpoint {
    Global = 'Global',
    Germany = 'Germany',
    China = 'China',
    Government = 'Government'
}

